var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-time-select',_vm._b({ref:"input",staticClass:"input-sigarus-time-select",attrs:{"clearable":false,"picker-options":{
		start: '00:00',
		step: '00:15',
		end: '23:30'
	}},on:{"change":function($event){return _vm.$emit('save')},"focus":function($event){return _vm.$emit('focus')},"blur":function($event){return _vm.$emit('blur')}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'el-time-select',_vm.getBind(),false))}
var staticRenderFns = []

export { render, staticRenderFns }